// eslint-disable-next-line no-use-before-define
import React from 'react';
import { generatePath, Link, useRouteMatch } from 'react-router-dom';
import './ROSideNav.scss';
import { BackLink } from './BackLink';

interface ROPatientDashboardNavType {
  id: string;
  oncologyType: string;
}

export const PatientSummaryLink = (): JSX.Element => {
  const match = useRouteMatch<ROPatientDashboardNavType>();
  const { id: patientId, oncologyType } = match.params;
  const url = generatePath(`/${oncologyType}/patient/${patientId}/summary`);

  return <BackLink url={url} title="Patient summary" />;
};
